module.exports = __webpack_public_path__ + "img/20201003_152005.e55007c0.jpg";